import CtaButton from './CtaButton';
import './InstructionsSection.css';

const updateSteps = [
  'Connect your GPS device to a computer using the manufacturer cable.',
  'Install the required map update software from the official provider.',
  'Sign in to your account and register your device if prompted.',
  'Check for available map updates and confirm compatibility.',
  'Download the update package to your computer or directly to the device.',
  'Follow on-screen prompts to install maps without disconnecting the device.',
];

const installSteps = [
  'Keep the GPS connected to power for the entire installation process.',
  'Do not disconnect the device while updates are running.',
  'Restart the device after installation and verify map version in settings.',
];

const detailedSteps = [
  'Back up existing maps if your software provides a backup option.',
  'Close other programs that may interrupt the USB connection.',
  'Use a direct USB port on the computer — avoid unpowered hubs when possible.',
  'Confirm sufficient storage space on the device or memory card.',
  'Download maps over a stable Wi-Fi or wired connection.',
  'Accept license terms and verify the correct region was selected.',
  'Allow installation to complete fully before unplugging.',
  'Run a short test route near your location to confirm routing works.',
  'Contact support if maps fail to load or the device does not boot normally.',
];

export default function InstructionsSection() {
  return (
    <section className="section instructions-section" id="guides">
      <div className="container">
        <h2 className="section-title center">GPS Map Update Guides</h2>
        <p className="section-lead center">
          Follow these step-by-step instructions to download, install, and verify your latest GPS maps.
        </p>

        <div className="guide-grid">
          <article className="guide-card">
            <h3>GPS Map Updates</h3>
            <ol>
              {updateSteps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </article>

          <article className="guide-card">
            <h3>GPS Map Installing</h3>
            <ol>
              {installSteps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </article>

          <article className="guide-card guide-card--wide">
            <h3>Instructions to Update GPS</h3>
            <ol>
              {detailedSteps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          </article>
        </div>

        <div className="guide-cta">
          <p>Need hands-on help with any step?</p>
          <CtaButton className="btn btn-primary btn--inline">Get Update Support</CtaButton>
        </div>
      </div>
    </section>
  );
}
